module.exports = __webpack_public_path__ + "static/media/10.2f3d8589.png";